module.exports = __webpack_public_path__ + "img/1998_L.4303628d.png";